import React from 'react';
import PropTypes from 'prop-types';
import { usePassengerAncillaries } from 'hooks/store/productsCart/usePassengerAncillaries';
import PricingRow from '../../ui/atoms/PricingRow';

/**
 * ProductsBreakdown component.
 * Displays a breakdown of selected ancillaries (products) for a specific passenger.
 * Retrieves ancillaries data from the purchase state which contains complete information.
 * Shows ancillaries for the specified segment.
 *
 * @param {object} props - tripSlug, passengerId, segment.
 * @param {string} props.tripSlug - Trip slug identifier.
 * @param {string|number} props.passengerId - Passenger ID.
 * @param {string} props.segment - Segment identifier: 'outgoing' or 'incoming'.
 * @returns {JSX.Element|null} - ProductsBreakdown component or null if no products.
 */
const ProductsBreakdown = ({ tripSlug, passengerId, segment }) => {
  // Get ancillaries for the specified segment
  const ancillaries = usePassengerAncillaries(passengerId, segment);

  // Only render if there are ancillaries for this segment
  if (!ancillaries || ancillaries.length === 0) {
    return null;
  }

  return (
    <>
      {ancillaries.map((ancillary) => (
        <PricingRow
          key={`${tripSlug}-${passengerId}-${segment}-${ancillary.code}`}
          label={`${ancillary.quantity} ${ancillary.name}`}
          price={ancillary.price}
        />
      ))}
    </>
  );
};

ProductsBreakdown.propTypes = {
  tripSlug: PropTypes.string.isRequired,
  passengerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  segment: PropTypes.string.isRequired,
};

export default ProductsBreakdown;
